import { forwardRef, useId } from 'react';
import { cn } from 'lib/cn';
import { Field } from './Field';

const BASE =
  'h-10 w-full rounded-lg border bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 transition focus:outline-none focus:ring-2 focus:ring-brand-500/40 disabled:bg-surface-50 disabled:text-slate-400';

/**
 * Labelled text input. Supports an optional `leftAddon` (e.g. a "+91" prefix).
 */
export const Input = forwardRef(function Input(
  { label, error, hint, required, id, leftAddon, className, containerClassName, ...props },
  ref,
) {
  const autoId = useId();
  const inputId = id || autoId;
  const borderTone = error ? 'border-red-400' : 'border-surface-300';

  const control = leftAddon ? (
    <div
      className={cn(
        'flex items-stretch rounded-lg border focus-within:ring-2 focus-within:ring-brand-500/40',
        borderTone,
      )}
    >
      <span className="inline-flex items-center rounded-l-lg border-r border-surface-300 bg-surface-50 px-3 text-sm text-slate-500">
        {leftAddon}
      </span>
      <input
        id={inputId}
        ref={ref}
        className={cn(
          'h-10 w-full rounded-r-lg px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none',
          className,
        )}
        {...props}
      />
    </div>
  ) : (
    <input id={inputId} ref={ref} className={cn(BASE, borderTone, className)} {...props} />
  );

  return (
    <Field
      label={label}
      htmlFor={inputId}
      error={error}
      hint={hint}
      required={required}
      className={containerClassName}
    >
      {control}
    </Field>
  );
});

export default Input;
